import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  insuranceCategoryList: [],
  insuranceCategoryById: {},
  insuranceCategoryByType: [],

  loading: {
    create: false,
    read: false,
    update: false,
    delete: false,
    getById: false,
    insuranceByType: false,
  },
  error: false,
  errorMessage: "",
};

const insuranceCategorySlice = createSlice({
  name: "insuranceCategory",
  initialState,
  reducers: {
    getInsuranceCategoryList(state, action) {
      state.insuranceCategoryList = action.payload;
      state.loading.read = false;
      state.error = false;
    },
    insuranceCategoryById(state, action) {
      state.insuranceCategoryById = action.payload;
      state.loading.getById = false;
      state.error = false;
    },
    insuranceCategoryByType(state, action) {
      state.insuranceCategoryByType = action.payload;
      state.loading.insuranceByType = false;
      state.error = false;
    },
    errorMessages(state, action) {
      state.errorMessage = action.payload;
      state.error = true;
      Object.keys(state.loading).forEach((key) => {
        state.loading[key] = false;
      });
    },
    hideErrorMessage(state) {
      state.error = false;
      state.errorMessage = "";
    },
    setLoading(state, action) {
      const { type, value } = action.payload;
      state.loading[type] = value;
    },
  },
});

export const {
  getInsuranceCategoryList,
  insuranceCategoryById,
  insuranceCategoryByType,
  errorMessages,
  setLoading,
  hideErrorMessage,
} = insuranceCategorySlice.actions;

export default insuranceCategorySlice.reducer;
export const insuranceCategoryReducer = insuranceCategorySlice.reducer;
